export const TEXT = {
    suggestionNomeUtente: "come verrano firmate le tue recensioni",
}